/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnBoardOrgUserDto } from '../../models/on-board-org-user-dto';
import { OnBoardOrgUserResponse } from '../../models/on-board-org-user-response';

export interface OnBoardOrganizationAndUser$Params {
      body: OnBoardOrgUserDto
}

export function onBoardOrganizationAndUser(http: HttpClient, rootUrl: string, params: OnBoardOrganizationAndUser$Params, context?: HttpContext): Observable<StrictHttpResponse<OnBoardOrgUserResponse>> {
  const rb = new RequestBuilder(rootUrl, onBoardOrganizationAndUser.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OnBoardOrgUserResponse>;
    })
  );
}

onBoardOrganizationAndUser.PATH = '/api/v2/onboard';
